"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpgradeModalItem = void 0;
const react_1 = __importDefault(require("react"));
const crate_1 = require("@tcc/crate");
const upgradeModalItem_css_1 = __importDefault(require("./upgradeModalItem.css"));
const UpgradeModalItem = ({ item }) => (react_1.default.createElement("div", { className: upgradeModalItem_css_1.default.itemContainer, "data-test-id": "upgrade-modal-item" },
    react_1.default.createElement(crate_1.Icon, { className: upgradeModalItem_css_1.default.itemBullet, glyph: crate_1.Icon.set.CHECK }),
    react_1.default.createElement("div", null, item)));
exports.UpgradeModalItem = UpgradeModalItem;
